import { ChevronLeft, ChevronRight } from 'lucide-react';
import { IconButton } from './IconButton.tsx';
import { cx } from './cx.ts';

/**
 * Page-based pagination strip. Position readout is mono
 * (`current / total`); labels arrive translated from the caller.
 */
interface Props {
  readonly page: number;
  readonly pageCount: number;
  readonly onPageChange: (page: number) => void;
  readonly prevLabel: string;
  readonly nextLabel: string;
  readonly ariaLabel: string;
  readonly className?: string;
  readonly testId?: string;
}

export function Pagination({
  page,
  pageCount,
  onPageChange,
  prevLabel,
  nextLabel,
  ariaLabel,
  className,
  testId,
}: Props): JSX.Element {
  return (
    <nav aria-label={ariaLabel} data-testid={testId} className={cx('flex items-center gap-2', className)}>
      <IconButton size="sm" label={prevLabel} disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        <ChevronLeft aria-hidden="true" className="h-4 w-4" />
      </IconButton>
      <span className="font-mono text-label text-paper-mid">
        {page} / {Math.max(pageCount, 1)}
      </span>
      <IconButton size="sm" label={nextLabel} disabled={page >= pageCount} onClick={() => onPageChange(page + 1)}>
        <ChevronRight aria-hidden="true" className="h-4 w-4" />
      </IconButton>
    </nav>
  );
}
